"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesMatcher = exports.defaultStyles = void 0;
exports.defaultStyles = {
    maskWrapper: () => ({
        opacity: 0.7,
        left: 0,
        top: 0,
        position: 'fixed',
        zIndex: 99999,
        pointerEvents: 'none',
        color: '#000',
    }),
    svgWrapper: ({ windowWidth, windowHeight, wpx, wpy }) => ({
        width: windowWidth,
        height: windowHeight,
        left: Number(wpx) / 2,
        top: Number(wpy) / 2,
        position: 'fixed',
    }),
    maskArea: ({ x, y, width, height }) => ({
        x,
        y,
        width,
        height,
        fill: 'black',
        rx: 0,
    }),
    maskRect: ({ windowWidth, windowHeight, maskID }) => ({
        x: 0,
        y: 0,
        width: windowWidth,
        height: windowHeight,
        fill: 'currentColor',
        mask: `url(#${maskID})`,
    }),
    clickArea: ({ windowWidth, windowHeight, clipID }) => ({
        x: 0,
        y: 0,
        width: windowWidth,
        height: windowHeight,
        fill: 'currentcolor',
        pointerEvents: 'auto',
        clipPath: `url(#${clipID})`,
    }),
    highlightedArea: ({ x, y, width, height }) => ({
        x,
        y,
        width,
        height,
        pointerEvents: 'auto',
        fill: 'transparent',
        display: 'none',
    }),
};
function stylesMatcher(styles) {
    return (key, state) => {
        const base = exports.defaultStyles[key](state);
        const custom = styles[key];
        return custom ? custom(base, state) : base;
    };
}
exports.stylesMatcher = stylesMatcher;
//# sourceMappingURL=styles.js.map